export enum StatisticTimeRange {
  YEAR = 'YEAR',
  FISCAL_YEAR = 'FISCAL_YEAR',
  QUARTER = 'QUARTER',
  MONTH = 'MONTH',
  DAY = 'DAY',
  CUSTOM = 'CUSTOM',
}
